import { yup } from '@jbc-year-end-adj/common/yup';
import { amountFormat } from '@jbc-year-end-adj/common/utils/formatter';

export const schema = yup.object({
  income: yup.object({
    mainJobIncome: yup
      .string()
      .positiveAmountFormat()
      .maxAmount(999999999)
      .label('給与所得 収入金額（当社）')
      .required(),
    sideJobIncome: yup
      .string()
      .positiveAmountFormat()
      .maxAmount(999999999)
      .label('給与所得 収入金額（他社）')
      .required()
  })
});

export type Income = {
  mainJobIncome: string;
  sideJobIncome: string;
};

export type Schema = {
  income: Income;
};

export const generateDefaultValues = (income: Income): Schema => {
  return {
    income: {
      mainJobIncome: amountFormat(income?.mainJobIncome),
      sideJobIncome: amountFormat(income?.sideJobIncome)
    }
  };
};
